<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
export default {
  name: 'Osm'
}

</script>



// WEBPACK FOOTER //
// src/Osm/containers/Osm.vue